'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _Object$assign = _interopDefault(require('babel-runtime/core-js/object/assign'));
var $ = _interopDefault(require('jquery'));
var keyCodes = _interopDefault(require('../global/keycodes.js'));
var utils_js = require('../helpers/utils.js');
var Carousel = _interopDefault(require('./carousel.js'));

function Tabs(el, options) {
  this.$el = utils_js.isJquery(el) ? el : $(el);
  this.config = _Object$assign({
    tabNav: '.tabs__nav',
    tabNavItems: '.tabs__nav-link',
    tabItems: '.tabs__item',
    setInitialState: true
  }, options);

  if (!this.$el.length) {
    return;
  }

  this.$tabNav = this.$el.find(this.config.tabNav);
  this.$tabNavItems = this.$el.find(this.config.tabNavItems);
  this.$tabItems = this.$el.find(this.config.tabItems);

  this.setInitialState = this.setInitialState.bind(this);
  this.removeState = this.removeState.bind(this);
  this.updateState = this.updateState.bind(this);
  this._onKeydown = this._onKeydown.bind(this);

  if (this.config.setInitialState) {
    this.setInitialState();
  }
}

Tabs.prototype.setInitialState = function () {
  this.carousel = new Carousel(this.$el, {
    carouselItem: this.config.tabItems,
    carouselNavItem: this.config.tabNavItems
  });

  this.$tabNav.attr('role', 'tablist');

  for (var index = 0; index < this.carousel.itemsCount; index++) {
    var id = utils_js.uniqueId('Tabs');

    this.$tabNavItems.eq(index).attr({
      'aria-controls': id,
      role: 'tab',
      href: '#' + id
    });

    this.$tabItems.eq(index).attr({
      id: id,
      role: 'tabpanel',
      tabindex: '0'
    });
  }

  this.$el.on('change', this.updateState);
  this.$tabNavItems.on('keydown', this._onKeydown);

  // Catch up our state with `this.carousel`
  this.updateState();
};

Tabs.prototype.removeState = function () {
  this.$tabNav.removeAttr('role');
  this.$tabNavItems.removeAttr('aria-controls aria-selected role');
  this.$tabItems.removeAttr('aria-hidden id role');
};

Tabs.prototype.updateState = function () {
  // Update tabs
  this.$tabNavItems.attr({
    'aria-selected': 'false',
    tabindex: '-1'
  }).eq(this.carousel.currentIndex).attr({
    'aria-selected': 'true',
    tabindex: '0'
  });

  // Update tabpanels
  this.$tabItems.attr('aria-hidden', 'true').eq(this.carousel.currentIndex).attr('aria-hidden', 'false');
};

Tabs.prototype._onKeydown = function (evt) {
  var newIndex = void 0;

  switch (evt.keyCode) {
    case keyCodes.UP:
    case keyCodes.LEFT:
      newIndex = this.carousel.prevIndex;
      break;

    case keyCodes.DOWN:
    case keyCodes.RIGHT:
      newIndex = this.carousel.nextIndex;
      break;

    case keyCodes.HOME:
      newIndex = 0;
      break;

    case keyCodes.END:
      newIndex = this.carousel.itemsCount - 1;
      break;
  }

  if (typeof newIndex !== 'undefined') {
    evt.preventDefault();
    this.$tabNavItems.eq(newIndex).trigger('click').trigger('focus');
  }
};

module.exports = Tabs;
